import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'ramda';

import styleFile from './SelectPayform.js';
import {withThemeJSS} from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import {List, Map} from 'immutable';
import classnames from 'classnames/bind';

const styles = (theme) => ({
    option: base => ({
        ...base,
        backgroundColor: 'red'
    }),
    control: base => ({
        ...base,
        border: 'none',
        borderRadius: 0,
        boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.5)',
        '&:hover': {
            border: 'none',
            boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.5)'
        }
    }),
    indicatorSeparator: base => ({
        display: 'none'
    }),
    menu: base => ({
        ...base,
        marginTop: '1px',
        borderRadius: 0,
        border: '1px solid #2684FF',
        boxShadow: '0 4px 2px -2px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
        padding: '0'
    }),
    dropdownIndicator: base => ({
        ...base,
        color: theme,
        '&:hover': {
            color: theme
        }
    }),
    indicatorsContainer: base => ({
        ...base,
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0
    }),
    menuList: base => ({
        ...base,
        paddingLeft: 10,
        paddingRight: 10
    }),
    input: base => ({
        ...base,
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        position: 'absolute'
    })
});
const PayFormSingleValue = compose(
    withThemeJSS({styleFile, displayName: 'SelectPayform'})
)(props => {
    const {classes} = props.theme.styles;

    let cx = classnames.bind(classes);

    return (
        <div {...props.innerProps} className={cx('row', 'test')}>
            <div className={props.cx(classes.title, {disabled: props.isFocused})}>
                <RichText ucFirst={true} innerStyle={['roboto13SoftGray']} text={'_%forma de pago%_'} translate={true}/>
            </div>
            <RichText
                ucFirst={true}
                innerStyle={[
                    'roboto16Black',
                    classes.optionTitle,
                    cx({isFocused: props.isFocused, isSelected: props.isSelected})
                ]}
                text={props.data.get('name')}
                translate={true}
            />
        </div>
    );
});

const PayFormOption = compose(
    withThemeJSS({styleFile, displayName: 'SelectPayform'})
)(props => {
    const {classes} = props.theme.styles;
    let cx = classnames.bind(classes);
    return (
        <div {...props.innerProps} className={cx('row', 'test')}>
            <RichText
                ucFirst={true}
                innerStyle={['roboto16Black', cx({isFocused: props.isFocused, isSelected: props.isSelected})]}
                text={props.data.get('name')}
                translate={true}
            />
        </div>
    );
});

const StaticPayForm = props => {
    const {payForms, classes} = props;
    return (
        payForms.size === 1 && (
            <div
                className={
                    payForms.size === 1 && ['htl', 'op'].includes(payForms.getIn([0, 'code']))
                        ? classes.hide
                        : classes.staticPayForm
                }>
                <RichText ucFirst={true} innerStyle={classes.paymentMethod} text={'_%forma de pago%_'}
                          translate={true}/>
                <RichText
                    ucFirst={true}
                    innerStyle={['roboto16Black', classes.optionTitle]}
                    text={payForms.getIn([0, 'name'])}
                    translate={true}
                />
            </div>
        )
    );
};

class SelectPayform extends React.Component {
    static displayName = 'SelectPayform';

    render() {
        const {payForms, defaultValue} = this.props.config;
        const {classes} = this.props.theme.styles;
        return (
            <div className={classes.selectBox}>
                <div>
                    <SelectField
                        getOptionLabel={option => option.get('name')}
                        getOptionValue={option => option.get('code')}
                        defaultValue={payForms.find(payForm => payForm.get('code') === defaultValue) || payForms.get(0)}
                        model={'payForm'}
                        options={payForms}
                        isSearchable={false}
                        isClearable={false}
                        components={{
                            Option: PayFormOption,
                            SingleValue: PayFormSingleValue
                        }}
                        styles={styles(this.props.theme.themeValues.mainColor)}
                        innerStyle={payForms.size === 1 ? [classes.hide] : [classes.inputSelect]}
                    />
                </div>
                <StaticPayForm payForms={payForms} notRefundable={false} classes={classes}/>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {};
};

const mapStateToProps = (store, ownProps) => {
    const onlinePayForm = Map({code: 'op', name: 'pago online'});
    let finalPayForms = List();
    finalPayForms = finalPayForms.push(onlinePayForm);
    return {
        payForms: finalPayForms,
    };
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    PropertyManager(['payForms', 'defaultValue', 'reservationPaid']),
    withThemeJSS({styleFile, link: true})
)(SelectPayform);
